import type { PriceGridFilterState } from './types';

const SHOW_RFQ_KEY = 'showRFQ';

export function getShowRFQ(filterState: PriceGridFilterState) {
  return filterState.custom?.[SHOW_RFQ_KEY] !== false;
}

export function setShowRFQ(filterState: PriceGridFilterState, enabled: boolean) {
  // Store `undefined` (absent) for the default-enabled state to keep persisted state minimal;
  // only the disabled case (`false`) needs an explicit value.
  return {
    ...filterState,
    custom: {
      ...filterState.custom,
      [SHOW_RFQ_KEY]: enabled ? undefined : false,
    },
  };
}
